import * as React from 'react'
import { styled } from 'next-yak'

import * as colors from '../../../../constants/colors'
import { lightweight, standalone, type SymbolProps } from '../../../spritesheetUtils'
import * as illustration from '../../Illustration'

const ID = 'compta-illustration-icon'

export function ComptaSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 90 80">
      <g>
        <path
          d="M67.7 15.8h-1.2V3.9c0-2.1-1.7-3.9-3.9-3.9H35.5c-.7 0-1.4.3-1.8.9S24 11 24 11c-.2.4-.4.8-.4 1.3v53c0 2.1 1.7 3.9 3.9 3.9h7.4c0 2.6 2.1 4.7 4.7 4.7h28c1.3 0 2.5-.5 3.4-1.4.8-.9 1.4-2 1.4-3.3V20.5c0-2.6-2.1-4.7-4.7-4.7Z"
          strokeWidth="0"
          fill="currentColor"
        />
        <path
          d="M57.8 44.9H36c-1.5 0-2.7-1.2-2.7-2.7v-9.3c0-1.5 1.2-2.7 2.7-2.7h21.8c1.5 0 2.7 1.2 2.7 2.7v9.3c0 1.6-1.2 2.8-2.7 2.8ZM36 32.4c-.2 0-.4.2-.4.4v9.3c0 .2.2.4.4.4h21.8c.2 0 .4-.2.4-.5v-9.3c0-.2-.2-.4-.4-.4H36ZM57.8 72.5h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-9.3c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v9.3c0 1.6-1.2 2.8-2.7 2.8ZM56.2 60c-.2 0-.4.2-.4.4v9.3c0 .2.2.4.4.4h1.6c.2 0 .4-.2.4-.5v-9.3c0-.2-.2-.4-.4-.4h-1.6ZM47.7 72.5h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 .7-.2 1.4-.7 1.9-.5.6-1.3.9-2.1.9ZM46 67.7c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.1 0 .3 0 .3-.1v-2c0-.2-.2-.4-.4-.4h-1.6ZM37.7 72.4h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 1.5-1.2 2.7-2.7 2.7ZM36 67.6c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.2 0 .4-.2.4-.4V68c0-.2-.2-.4-.4-.4H36ZM47.7 64.9h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 .7-.2 1.4-.7 1.9-.5.6-1.3.9-2.1.9ZM46 60.1c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.1 0 .3 0 .3-.1v-2c0-.2-.2-.4-.4-.4h-1.6ZM37.7 64.9h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 1.5-1.2 2.7-2.7 2.7ZM36 60.1c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.2 0 .4-.2.4-.4v-1.6c0-.2-.2-.4-.4-.4H36ZM37.7 57.1h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 1.5-1.2 2.7-2.7 2.7ZM36 52.3c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.2 0 .4-.2.4-.4v-1.6c0-.2-.2-.4-.4-.4H36ZM47.7 57.1h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 .7-.2 1.4-.7 1.9-.5.6-1.3.9-2.1.9ZM46 52.3c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.1 0 .3 0 .3-.1v-2c0-.2-.2-.4-.4-.4h-1.6ZM57.8 57.1h-1.6c-1.5 0-2.7-1.2-2.7-2.7v-1.6c0-1.5 1.2-2.7 2.7-2.7h1.6c1.5 0 2.7 1.2 2.7 2.7v1.6c0 1.5-1.2 2.7-2.7 2.7Zm-1.6-4.8c-.2 0-.4.2-.4.4v1.6c0 .2.2.4.4.4h1.6c.2 0 .4-.2.4-.4v-1.6c0-.2-.2-.4-.4-.4h-1.6Z"
          strokeWidth={0}
          fill={colors.PRIMARY_GREY_900}
        />
        <path
          d="M60.8 22.3h-.7V10c0-2.1-1.7-3.8-3.8-3.8H29.5c-.7 0-1.4.3-1.8.9s-9.7 10-9.7 10c-.2.4-.4.8-.4 1.3V71c0 2.1 1.7 3.8 3.8 3.8h6.9v.5c0 2.6 2.1 4.7 4.7 4.7h27.8c2.6 0 4.7-2.1 4.7-4.7V27c0-2.6-2.1-4.7-4.7-4.7ZM27 10.9V16h-4.9l4.9-5.1ZM28.3 27v45.4h-7c-.8 0-1.5-.7-1.5-1.6V18.4l.2-.2h9.3V8.4h26.9c.8 0 1.5.6 1.5 1.5v12.4H33c-2.6 0-4.7 2.1-4.7 4.7Zm34.9 48.2c0 1.3-1 2.4-2.4 2.4H33c-1.3 0-2.4-1-2.4-2.4V27c0-1.3 1-2.4 2.4-2.4h27.8c1.3 0 2.4 1 2.4 2.4v48.3Z"
          strokeWidth={0}
          fill={colors.PRIMARY_GREY_900}
        />
      </g>
    </symbol>
  )
}

const ComptaStandaloneContent = standalone(ComptaSymbol, ID)

export const Compta = styled(function ComptaStandaloneComponent(props: illustration.SpecificIllustrationProps) {
  return (
    <illustration.Illustration {...props} name="compta">
      <ComptaStandaloneContent />
    </illustration.Illustration>
  )
})`
  fill: none;
`

export const ComptaLightweight = styled(function ComptaComponent(props: illustration.SpecificIllustrationProps) {
  return (
    <illustration.Illustration {...props} name="compta">
      {lightweight(ID)}
    </illustration.Illustration>
  )
})`
  fill: none;
`
